import { render, staticRenderFns } from "./studentsByAge.vue?vue&type=template&id=f8a7829e&scoped=true&"
import script from "./studentsByAge.js?vue&type=script&lang=js&"
export * from "./studentsByAge.js?vue&type=script&lang=js&"
import style0 from "./studentsByAge.scss?vue&type=style&index=0&id=f8a7829e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a7829e",
  null
  
)

export default component.exports